Vue.component('teamleaderboard', {
    template: templates.teamLeaderBoard,
    data() {
      return {
        model: {
     
        }
      }
    },
    mounted() {
      const c = this;
     
    },
    methods: {
     
  
    
    
    }
  });